import UserService from "@/services/user.service.js";

export default class UserUsecase {
  constructor () {
    this.UserService = new UserService();
  }

  async getMe () {
    const res = await this.UserService.me();
    return res;
  }

  async getUser (option) {
    const res = await this.UserService.list(option);
    return res;
  }

  async getUsers (options) {
    const res = await this.UserService.get(options);
    return res;
  }

  async getClientGroups (options) {
    const res = await this.UserService.getClientList(options);
    return res;
  }

  async createUser (options) {
    const res = await this.UserService.insert(options);
    return res;
  }

  async updateUser (options) {
    const res = await this.UserService.update(options);
    return res;
  }

  async deleteUser (options) {
    const res = await this.UserService.delete(options);
    return res;
  }

  async getAdminUsers (options) {
    const res = await this.UserService.get(options);
    return res;
  }
}
